import { Vue } from 'vue-class-component';
import { lockScroll, unlockScroll } from '@/common/helpers';
import styles from './styles.module.scss';

export class Scrollable extends Vue {
	mounted() {
		lockScroll(this.$refs.content as HTMLElement);
	}

	beforeUnmount() {
		unlockScroll(this.$refs.content as HTMLElement);
	}

	render() {
		return (
			<div class={ styles.scrollable } ref="content">
				{ this.$slots.default && this.$slots.default() }
			</div>
		);
	}
}
